import { HttpParameterCodec } from '@angular/common/http';

/**
 * Due to weird and not-standard HttpParameterCodec design, we want to use our own.
 * See https://github.com/angular/angular/issues/11058 for more details.
 */
export class PlacewiseHttpParamsCodec implements HttpParameterCodec {
  public encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  public encodeValue(value: string): string {
    return encodeURIComponent(value);
  }

  public decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  public decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}
